import {COOKIE_VALUE, FLAGS, POPUP_TYPE} from 'general/constants';
import {get} from 'svelte/store';
import {dyData} from 'general/store';
import {setCookie} from 'general/libs/setCookie';
import {getCookie} from 'general/libs/getCookie';

const halfAnHour = 0.0208;

/**
 * Show an open Welcome popup.
 * If the user closes the popup, he sees it open only the next day.
 * The method allows you to show a popup open every 30 minutes session,
 * the session is extended with each request to the popup.
 * @param {string} popupType popup type
 */
export const expShowPopupSession = (popupType: string): void => {
    const isExpSession = get(dyData).flag === FLAGS.SESSION;
    const isPopupSession = getCookie(COOKIE_VALUE.POPUP_SESSION);

    if (!isExpSession) return;

    if (isPopupSession) {
        setCookie(COOKIE_VALUE.POPUP_SESSION, 'true', halfAnHour);
    }

    if (popupType === POPUP_TYPE.WELCOME && isExpSession && !isPopupSession) {
        setCookie(COOKIE_VALUE.POPUP_CLOSE, 'true', 0);
        setCookie(COOKIE_VALUE.REMINDER_CLOSE, 'true', 0);
        setCookie(COOKIE_VALUE.POPUP_SESSION, 'true', halfAnHour);
    }
};
